<template>
  <section :class="['row', 'row--split', { 'row--slidup': isInView }]">
    <div class="row__content about">
      <header class="row__header">
        <h2 class="row__title row__title--small">
          Czym jest
          <span class="row__highlight">Caredo?</span>
        </h2>
      </header>

      <div class="about__content">
        <p class="about__text">
          To nowoczesne, zaprojektowane z dbałością o najwyższą jakość rozwiązanie, które zostało
          stworzone z myślą o branży motoryzacyjnej.
        </p>
        <p class="about__text">
          Dzięki niemu Twój Klient może przekazać, a później odebrać auto z serwisu w dowolnym,
          najbardziej wygodnym dla siebie terminie.
        </p>
        <p class="about__text">
          Prosto, komfortowo i bez konieczności bezpośredniego kontaktu z osobami trzecimi.
        </p>
        <p class="about__hours">
          <img :src="require('@/assets/img/icon-alarm.svg')" class="about__icon" />
          24/7
        </p>
      </div>
    </div>
    <div class="row__image">
    <div class="swiper row__image_content"></div>
    <!-- <div class="swiper row__image_content">
    </div> -->
      <!-- <swiper class="swiper" :options="swiperOptions">
        <swiper-slide>
          <img :src="require('@/assets/img/caredo_box.jpg')" />
        </swiper-slide>
  <swiper-slide>
          <img :src="require('@/assets/img/swiper-2.jpg')" />
        </swiper-slide> -->
        <!-- <swiper-slide>
          <img :src="require('@/assets/img/swiper-3.jpg')" />
        </swiper-slide>
        <swiper-slide>
          <img :src="require('@/assets/img/swiper-4.jpg')" />
        </swiper-slide> -->
      <!-- </swiper> -->

      <!-- <div class="swiper__buttons">
        <button class="swiper__btn swiper__btn--prev">
          <img :src="require('@/assets/img/icon-left.svg')" class="swiper__icon" />
        </button>
        <button class="swiper__btn swiper__btn--next">
          <img :src="require('@/assets/img/icon-right.svg')" class="swiper__icon" />
        </button>
      </div> -->
    </div>
  </section>
</template>

<script>
// import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';

export default {
  name: 'swiper-section',
  components: {
    // Swiper,
    // SwiperSlide,
  },
  data: () => ({
    swiperOptions: {
      loop: true,
      speed: 700,
      navigation: {
        nextEl: '.swiper__btn--next',
        prevEl: '.swiper__btn--prev',
      },
      autoplay: {
        delay: 2500,
      },
    },
  }),
};
</script>

<style lang="scss" scoped>
.row{
  padding-bottom: 0;;
}
.about {
  text-align: left;
}

.about__content {
  margin: 80px 0 0 80px;

  @media screen and (max-width: 1000px) {
    margin-top: 40px;
  }

  @media screen and (max-width: 550px) {
    margin-left: 10vw;
  }
}

.about__text {
  font-size: 1.125em;
  line-height: 1.556em;

  @media screen and (max-width: 1000px) {
    font-size: 1em;
  }
}

.about__hours {
  align-items: center;
  display: flex;
  margin-top: 50px;
}

.about__icon {
  margin-right: 30px;
}

.swiper {
  height: 50vw;
  min-height: 300px;

  @media screen and (min-width: 1920px) {
    height: 960px;
  }

  @media screen and (max-width: 1000px) {
    height: 40vw;
  }

  @media screen and (max-width: 900px) {
    height: 50vw;
  }
}

.swiper-slide, .row__image_content{
  img {
    display: block;
    height: 100%;
    object-fit: cover;
    width: 100%;
  }
}
.row__image_content{
background-image: url('../assets/img/caredo_box_1.jpg');
background-position: center;
background-repeat: no-repeat;
background-size: cover;
 @media screen and (max-width: 900px) {
   background-size: contain;
   background-image: url('../assets/img/caredo_box.jpg');
   background-repeat: no-repeat;
  }
}

.swiper__buttons {
  bottom: 50px;
  left: 50px;
  position: absolute;
  z-index: 9999;
}

.swiper__btn {
  background: none;
  border: 0;
  cursor: pointer;
  margin: 0;
  padding: 0;
  z-index: 9999;

  &:first-child {
    margin-right: 30px;
  }
}

</style>
